// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"TextArea_TextArea__2xXSc","TextArea_error":"TextArea_TextArea_error__1yMgx"};